import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}
  public transform(html: string): any {
    // mark any iframe as "sandbox" for safety
    const sandboxedHtml = html.replace(
      '<iframe',
      '<iframe sandbox="allow-scripts allow-same-origin allow-presentation"'
    );
    return this.domSanitizer.bypassSecurityTrustHtml(sandboxedHtml);
  }
}
